/* eslint no-nested-ternary: 0 */

import PropTypes from 'prop-types';

import React, { Component } from 'react';
import { reduxForm } from 'redux-form';
import { tokenLimitReset } from '../../../redux/actions/tokenLimit';
import en from '../../../international/translations/en';
import config from '../../../config';
import spinner from '../../../../static/btn-spinner.svg';

class ContinueForm extends Component {
  static propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    submitFunc: PropTypes.func,
    tokenAboveLimit: PropTypes.bool,
    submitting: PropTypes.bool.isRequired,
    formLocation: PropTypes.string,
    emailRedirect: PropTypes.func,
  };

  constructor(props) {
    super(props);
    this.analyticsClickedCancel = this.analyticsClickedCancel.bind(this);
    this.analyticsClickedRecover = this.analyticsClickedRecover.bind(this);
  }

  componentWillMount() {
    this.props.initializeForm({
      email: this.props.userData.email,
      password: this.props.userData.password,
      staySignedIn: true,
      client_id: config.client_id,
      tokenAboveLimit: this.props.tokenAboveLimit,
      forced: 'true',
      location: this.props.formLocation
    });
    window.analytics.page('Device Limit', 'Reached Device Limit', {email: this.props.userData.email});
  }
  componentWillUnmount() {
    this.resetTokenLimit();
  }

  resetTokenLimit() {
    this.props.dispatch(tokenLimitReset());
  }

  analyticsClickedCancel() {
    window.analytics.track('Clicked Cancel', {email: this.props.userData.email, pageName: 'Device Limit'});
    this.resetTokenLimit();
  }

  analyticsClickedRecover() {
    window.analytics.track('Clicked Recover Account', {email: this.props.userData.email, pageName: 'Device Limit'});
    this.props.emailRedirect(this.props.userData.email);
  }

  render() {
    const {
      handleSubmit,
      submitFunc,
      submitting
      } = this.props;

    return (
      <form onSubmit={handleSubmit(submitFunc)}>
        <div className="continueForm">
          <div className="continueForm__title">{en.sign_in.continueform.title}</div>
          <div className="continueForm__info">{en.sign_in.continueform.info}</div>
          <div className="continueForm__faq"><a href={config.deviceLimitFaqLink} target="_blank">{en.sign_in.continueform.faq_text}</a></div>
          <div className="continueForm__buttons">
            <div className="continueForm__recover__button">
              <a className="continueForm__recover_account__link" onClick={this.analyticsClickedRecover}>{en.sign_in.continueform.recover_button}</a>
            </div>
            <button className="continueForm__continue__button">
                {submitting ? <img src={spinner} className="continueForm__button__submit__submitting__img" /> : en.sign_in.continueform.continue_button}
            </button>
            <div className="continueForm__goback__div">
              <a className="continueForm__goback__link" onClick={this.analyticsClickedCancel}>{en.sign_in.continueform.go_back_link}</a>
            </div>
          </div>
        </div>
      </form>
    );
  }
}

export default reduxForm({
  form: 'Continue',
  fields: ['email', 'password', 'staySignedIn', 'client_id', 'tokenAboveLimit', 'forced', 'location']
})(ContinueForm);
